// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CuisineGenre-module__wrapper___k1tiU{\n  width: 100%;\n  padding: 16px 0 20px 0;\n}\n.CuisineGenre-module__scrollControll___AJcGT {\n  display: flex;\n  max-height: 730px;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  overflow: scroll;\n}\n.CuisineGenre-module__selectionWrapper___hyOcC {\n  display: flex;\n  width: 310px;\n  flex-direction: column;\n  grid-gap: 30px;\n  grid-gap: 30px;\n  gap: 30px;\n  justify-content: center;\n  padding: 16px 0 16px 0;\n  flex-wrap: wrap;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": "CuisineGenre-module__wrapper___k1tiU",
	"scrollControll": "CuisineGenre-module__scrollControll___AJcGT",
	"selectionWrapper": "CuisineGenre-module__selectionWrapper___hyOcC"
};
export default ___CSS_LOADER_EXPORT___;
